export const TRANSLATION_KEYS = {
    Heading: "settingPage.customViewPage.formDrawer.heading",
    ConfirmText: "common.saveText",
    DismissText: "common.dismissText",
    ViewNameLabel: "settingPage.customViewPage.formDrawer.viewNameLabel",
    ViewNamePlaceholder: "settingPage.customViewPage.formDrawer.viewNamePlaceholder",
    ViewNameErrorMessage: "settingPage.customViewPage.formDrawer.viewNameErrorMessage",
    AssignToLabel: "settingPage.customViewPage.formDrawer.assignToLabel",
    StatusLabel: "settingPage.customViewPage.formDrawer.statusLabel",
    StatusPlaceholder: "settingPage.customViewPage.formDrawer.statusPlaceholder",
    TimePeriodLabel: "settingPage.customViewPage.formDrawer.timePeriodLabel",
    TimePeriodPlaceholder: "settingPage.customViewPage.formDrawer.timePeriodPlaceholder",
    StatusOptionCanceled: "common.ticketStatus.statusOptionCanceled",
    StatusOptionClosed: "common.ticketStatus.statusOptionClosed",
    StatusOptionDeleted: "common.ticketStatus.statusOptionDeleted",
    StatusOptionOpen: "common.ticketStatus.statusOptionOpen",
    StatusOptionPending: "common.ticketStatus.statusOptionPending",
    StatusOptionWorking: "common.ticketStatus.statusOptionWorking",
    TimePeriodOptionCurrentWeek: "common.timePeriod.timePeriodOptionCurrentWeek",
    TimePeriodOptionCurrentMonth: "common.timePeriod.timePeriodOptionCurrentMonth",
    TimePeriodOptionLast7Days: "common.timePeriod.timePeriodOptionLast7Days",
    TimePeriodOptionLast30Days: "common.timePeriod.timePeriodOptionLast30Days",
};